/*eslint no-magic-numbers: ["error", { "ignore": [0, 4] }]*/
import React, { useState } from 'react'

import MultiSelectionDropdown from 'components/MultiSelectDropdown'

import { FiltersContentContainer } from '../style'
import { getSelectedOptions } from '../index'
import qs from 'query-string'


export const getSpeciesListUrl = (selectedSpecies) => {
  return qs.stringify({
    taxonId: selectedSpecies.toString()
  })
}

const SpeciesFiltersContent = ({item, updateFilters, filterTitle, getSpecieOptions, specieOptions, setSpecieOptions}) => {
  const [speciesList, setSpeciesList] = useState(item.speciesList)
  const [specieQuery, setSpecieQuery] = useState('')

  const handleChangeSpecieList = (e) => {
    setSpeciesList(e)
    updateFilters({ ...item, speciesList: e, selectedSpecieOptions: getSelectedOptions(e, specieOptions), url: getSpeciesListUrl(e) }, filterTitle)
    setSpecieOptions(getSelectedOptions(e, specieOptions))
  }

  const handleRemoveUnCheckedOptions = () => {
    setSpecieOptions(getSelectedOptions(speciesList, specieOptions))
  }

  const handleSearchSpecie = (e) => {

    setSpecieQuery(e)
    if(e.length > 4){
      return getSpecieOptions(e)
    }

    if (e.length === 4) {
      setSpecieOptions(getSelectedOptions(speciesList, specieOptions))
    }
  }

  return (
    <FiltersContentContainer>
      <MultiSelectionDropdown
        dataTest="Species"
        marginTop='16px'
        label='species'
        secondStepOptions={specieOptions}
        value={speciesList}
        saveChanges={handleChangeSpecieList}
        infoTooltip='specieFilterHint'
        inputValue={specieQuery}
        onInputChange={handleSearchSpecie}
        isSearchable={true}
        placeholder='searchByScientificName'
        selectAllOption={false}
        closeFunc={handleRemoveUnCheckedOptions}
      />
    </FiltersContentContainer>
  )
}

export default SpeciesFiltersContent
